import {AdviceTypes} from "./AdviceTypes";
import {CurrentUser} from "../../../../../services/user/models/CurrentUser";
import {ArrayUtil} from "../../../../../js/util/ArrayUtil";

export interface OrderAdvice {
    adviceCaptured: number;
    adviser: string;
    orderTaker: string;
    orderPlacer: string;
    adviceType: AdviceType | null;
    adviceMethod: string | null;
    adviceBasis: Array<string>;
    declarations: Array<string>;
    reference: string | null;
    comment: string | null;
}

export enum AdviceType {
    EXECUTION_ONLY = "EXECUTION_ONLY",
    PERSONAL = "PERSONAL",
    GENERAL = "GENERAL"
}

export function defaultAdvice(types: AdviceTypes, user: CurrentUser): OrderAdvice {
    const defaultMethod = types.method[0]?.key ?? null;

    return {
        adviceCaptured: Date.now(),
        adviser: user.username,
        orderTaker: user.username,
        orderPlacer: "",
        adviceType: null,
        adviceMethod: defaultMethod,
        adviceBasis: [],
        declarations: [],
        reference: null,
        comment: null
    };
}

export function isSameAdvice(a: OrderAdvice, b: OrderAdvice): boolean {
    return (a.adviceCaptured === b.adviceCaptured) &&
        (a.adviser === b.adviser) &&
        (a.orderTaker === b.orderTaker) &&
        (a.orderPlacer === b.orderPlacer) &&
        (a.adviceType === b.adviceType) &&
        (a.adviceMethod === b.adviceMethod) &&
        ArrayUtil.matchesExact(a.adviceBasis, b.adviceBasis) &&
        ArrayUtil.matchesExact(a.declarations, b.declarations) &&
        (a.reference === b.reference) &&
        (a.comment === b.comment);
}
